import { Fragment } from 'react';
import { observer } from 'mobx-react';

import { Ping } from './Ping';
import { VersionText } from './PlayAppVersion.styled';

export const DebugPin = observer(() => {
  return (
    <Fragment>
      {Ping.isVisible && Ping.value !== undefined && (
        <VersionText>Ping {Ping.value}ms</VersionText>
      )}
    </Fragment>
  );
});
